/** Recommandation affichée à l’upload — pas une contrainte de validation. */
export const CAMPAIGN_IN_APP_IMAGE_RECOMMENDED_WIDTH = 1500;
export const CAMPAIGN_IN_APP_IMAGE_RECOMMENDED_HEIGHT = 500;
export const CAMPAIGN_IN_APP_IMAGE_RECOMMENDED_RATIO = '3:1';

export const CAMPAIGN_IN_APP_IMAGE_FORMAT_HINT_TITLE =
  'Format recommandé : 1500 × 500 px (ratio 3:1)';

export const CAMPAIGN_IN_APP_IMAGE_FORMAT_HINT_BODY =
  'JPG, PNG ou WebP. Placez le texte et les éléments importants au centre de l’image : les bords peuvent être rognés selon la taille de l’écran.';

/** Aucune validation dimensionnelle côté Admin (recommandation UX uniquement). */
export const isCampaignImageDimensionRestricted = () => false;
